import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Link} from 'react-router-dom'
import * as wActs from '../actions/website-actions';
import * as wConst from '../consts/website-consts';
import {withRouter} from "react-router-dom";

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import UploadButton from 'react-upload-button-v2';
import SeoHeaders from "../components/SeoHeaders";
//import UploadButtonStyles from 'react-upload-button-v2/component/styles.css';


class Support extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showingSuccess: false, showingAlert: false,
      message: "Form was posted successfully"
    }
  }


  componentDidMount() {
    this.props.dispatch(wActs.GetSupportId());
    this.props.dispatch({ type: wConst.ACTION_SET_PAGETYPE, payload: "support" });
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  handleSubmit(evt) {

    let dta = {
      Name: this.formName.value,
      Email: this.formEmail.value,
      Message: this.formMessage.value,
      FileName: null,
      File: null
    };

    this.props.dispatch(wActs.SendSupportMessage(dta))


  }

  handleCloseAlert() {
    this.setState({ showingAlert: false });
  }
  handleCloseSuccess() {
    this.setState({ showingSuccess: false });
  }

  handleUpload(input) {
    this.uploadLabel.innerHTML = "&nbsp;&nbsp;" + input.files[0].name;
  }

  render() {

    //console.log('Support Status',this.props.WebPage.Support.Status);

    //setTimeout(() => window.PaintUpload(), 1000);


    let linkHome = "/"; //wActs.getCultPath(this.props.WebPage,"/");
    let linkSupport = "/support"; //wActs.getCultPath(this.props.WebPage,"/support");

    let hHtml = this.getTranslation("page.support.header");
    if(!wActs.isNullOrEmpty(this.props.WebPage.Page.Content.Main)) {
      hHtml = this.props.WebPage.Page.Content.Main;
    }

    return (
      <div className="container default-content" style={{display: "flex", justifyContent: "center"}}>
        <div className="row">
          <div className="col-sm-12">

            <div className="white-box default-content" style={{paddingTop: "20px"}}>
              <div className={"support-section-top"} dangerouslySetInnerHTML={{__html: hHtml }}></div>
              <div className="white-box-wrapper mb">
                <h3><FormattedMessage id={"page.support.writetous"}>{(...content) => content}</FormattedMessage></h3>
                {this.props.WebPage.Support.Status === wConst.SUPPORT_STATUS_FAILED &&
                  <div className={"support-alert"}>
                    {this.props.WebPage.Support.Message}
                  </div>
                }
                {this.props.WebPage.Support.Status === wConst.SUPPORT_STATUS_SUCCESS &&
                  <div className={"support-success"}>
                    {this.props.WebPage.Support.Message}
                  </div>
                }
                <div className="row">
                  <div className="col_50">
                    <div className="input-block">
                      <label><FormattedMessage id={"page.yourname"}>{(...content) => content}</FormattedMessage></label>
                      <input ref={(ref) => {this.formName = ref;}} type="text" placeholder="John Smith" name="" />
                    </div>
                  </div>
                  <div className="col_50">
                    <div className="input-block">
                      <label><FormattedMessage id={"page.email"}>{(...content) => content}</FormattedMessage></label>
                      <input ref={(ref) => {this.formEmail = ref;}} type="email" placeholder="example@gmail.com" name="" />
                    </div>
                  </div>
                  <div class="col_100">
                    <div className="input-block">
                      <label><FormattedMessage id={"page.yourmessage"}>{(...content) => content}</FormattedMessage></label>
                      <textarea ref={(ref) => {this.formMessage = ref;}}  placeholder={this.getTranslation("page.writeyourmessagehere")} defaultValue={this.props.WebPage.Support.Response.Text}></textarea>
                    </div>
                  </div>
                </div>

                <div className="floating-objects">
                  {/*
                  <div className="file-upload left">
                    <UploadButton
                      ref={(ref) => { this.fileUpload = ref; }}
                      style={{ width: '10em' }}
                      className="upload-button"
                      onChange={(input) => {this.handleUpload(input)}}>
                      <span ref={(ref) => {this.uploadLabel = ref;}}>&nbsp;&nbsp;<FormattedMessage id={"page.uploadattachment"}>{(...content) => content}</FormattedMessage></span>
                    </UploadButton>
                  </div>
                  */}
                  {this.props.WebPage.Support.Status === wConst.SUPPORT_STATUS_PENDING &&
                    <img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif`} width={"75"} height={"75"} alt={"loading..."} style={{margin: "auto", contentAlign: "center", justifyContent: "center", display: "flex"}}/>
                  }
                  {this.props.WebPage.Support.Status !== wConst.SUPPORT_STATUS_PENDING &&
                    <input type="button" onClick={(evt) => {this.handleSubmit(evt)}} value={this.getTranslation('page.sendmessage')} className="button right" name="" />
                  }
                  <div style={{clear: "both", height: "100px"}}></div>
                  </div>
              </div>

              {!wActs.isNullOrEmpty(this.props.WebPage.Page.Content.CompanyInfo) &&
              <div className={"support-section-top"} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.Content.CompanyInfo}}>

              </div>
              }
            </div>

          </div>
        </div>
      </div>




    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
  };
}

export default connect(mapStateToProps)(Support);
